import { Box, useTheme } from "@mui/material";
import classnames from "classnames";
import React from "react";
import { createPortal } from "react-dom";

import { Icon } from "./icons";

export interface ModalProps {
  open: boolean;
  onClose: () => unknown;
  className?: string;
  bodyClassName?: string;
  footerClassName?: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  sx?: object;
}

const modalElement =
  typeof window !== "undefined" ? document.getElementById("modal") : null;

export const Modal: React.FC<ModalProps> = (props) => {
  const {
    open,
    onClose,
    children,
    header,
    footer,
    className,
    bodyClassName,
    footerClassName,
    sx = {},
  } = props;
  const theme = useTheme();

  if (modalElement && open) {
    return createPortal(
      <Box
        className="modalBackdrop"
        sx={{
          position: "fixed",
          zIndex: 1300,
          inset: 0,
          background: "rgba(0,0,0,0.7)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          className={classnames("modal", className)}
          sx={{
            background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, #191919 100%)`,
            borderRadius: 2,
            boxShadow: `0 2px 12px ${theme.palette.primary.main}22`,
            border: `1px solid ${theme.palette.primary.main}22`,
            minWidth: 320,
            maxWidth: "95vw",
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
            ...sx,
          }}
        >
          <Box
            className="modalHeader"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3,
              py: 2,
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box className="modalHeaderContent">{header}</Box>
            <Icon
              icon={["fal", "times"]}
              size="lg"
              onClick={onClose}
              className="modalClose"
              style={{
                cursor: "pointer",
                color: theme.palette.text.secondary,
              }}
            />
          </Box>
          <Box
            className={classnames("modalBody", bodyClassName, "scroll-hide")}
            sx={{
              px: 3,
              py: 2,
              overflowY: "auto",
              color: theme.palette.text.primary,
              flex: 1,
            }}
          >
            {children}
          </Box>
          {footer && (
            <Box
              className={classnames("modalFooter", footerClassName)}
              sx={{
                px: 3,
                py: 2,
                borderTop: `1px solid ${theme.palette.divider}`,
                background: "transparent",
              }}
            >
              {footer}
            </Box>
          )}
        </Box>
      </Box>,
      modalElement
    );
  }
  return null;
};
